module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-email-92080ba232ec234c67b6baab6551fae9.svg";